document.addEventListener('DOMContentLoaded', function () {
  // Scroll-reveal animations
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Header shrink-on-scroll
  var header = document.querySelector('.site-header');
  if (header) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      lastY = window.scrollY;
    }, { passive: true });
  }

  // Search overlay
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput = document.getElementById('search-overlay-input');
  var searchResults = document.getElementById('search-overlay-results');
  var searchOpeners = document.querySelectorAll('[data-search-open]');
  var searchClosers = document.querySelectorAll('[data-search-close]');
  var searchDebounce;

  function openSearch(e) {
    if (e) e.preventDefault();
    if (searchOverlay) searchOverlay.classList.add('is-open');
    document.body.classList.add('search-open');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 300);
  }
  function closeSearch() {
    if (searchOverlay) searchOverlay.classList.remove('is-open');
    document.body.classList.remove('search-open');
  }
  searchOpeners.forEach(function (el) { el.addEventListener('click', openSearch); });
  searchClosers.forEach(function (el) { el.addEventListener('click', closeSearch); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  function renderSearchResults(data) {
    if (!searchResults) return;
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) {
      searchResults.innerHTML = '<p class="search-overlay__empty">No kits found. Try a different word.</p>';
      return;
    }
    searchResults.innerHTML = products.map(function (p) {
      var img = p.featured_image ? p.featured_image.url : (p.image || '');
      return '<a href="' + p.url + '" class="search-result">' +
        (img ? '<img src="' + img + '" alt="' + p.title + '">' : '') +
        '<div><p class="search-result__title">' + p.title + '</p>' +
        '<p class="search-result__price">' + (p.price || '') + '</p></div></a>';
    }).join('');
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(searchDebounce);
      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchResults.innerHTML = '<div class="search-overlay__loading"><span></span><span></span><span></span></div>';
      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title')
          .then(function (res) { return res.json(); })
          .then(renderSearchResults)
          .catch(function () {
            searchResults.innerHTML = '<p class="search-overlay__empty">Something went wrong. Try again.</p>';
          });
      }, 300);
    });
  }

  // Collection filter panel toggle
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      filterPanel.classList.toggle('is-open');
    });
  }

  // Scroll-row arrow navigation (category tabs, reels, carousels, testimonials)
  document.querySelectorAll('.scroll-row-wrap').forEach(function (wrap) {
    var row = wrap.querySelector('.scroll-row');
    var prev = wrap.querySelector('.scroll-arrow--prev');
    var next = wrap.querySelector('.scroll-arrow--next');
    if (!row) return;
    function scrollAmount() {
      var card = row.querySelector(':scope > *');
      return card ? card.getBoundingClientRect().width + 22 : 240;
    }
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -scrollAmount() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: scrollAmount() * 2, behavior: 'smooth' }); });
  });

  // Shoppable reel: click to play/pause
  document.querySelectorAll('.reel-card__media').forEach(function (media) {
    var video = media.querySelector('video');
    if (!video) return;
    media.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        media.classList.add('is-playing');
      } else {
        video.pause();
        media.classList.remove('is-playing');
      }
    });
    video.addEventListener('ended', function () { media.classList.remove('is-playing'); });
  });

  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      var menuIcon = toggle.querySelector('.icon-menu');
      var closeIcon = toggle.querySelector('.icon-close');
      if (menuIcon) menuIcon.style.display = isOpen ? 'none' : 'block';
      if (closeIcon) closeIcon.style.display = isOpen ? 'block' : 'none';
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        var menuIcon = toggle.querySelector('.icon-menu');
        var closeIcon = toggle.querySelector('.icon-close');
        if (menuIcon) menuIcon.style.display = 'block';
        if (closeIcon) closeIcon.style.display = 'none';
      });
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && !toggle.contains(e.target)) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        var menuIcon = toggle.querySelector('.icon-menu');
        var closeIcon = toggle.querySelector('.icon-close');
        if (menuIcon) menuIcon.style.display = 'block';
        if (closeIcon) closeIcon.style.display = 'none';
      }
    });
  }

  // Cart drawer
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-overlay');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart(e) {
    if (e) e.preventDefault();
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartOpeners.forEach(function (el) { el.addEventListener('click', openCart); });
  cartClosers.forEach(function (el) { el.addEventListener('click', closeCart); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('.cart-drawer');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    var bubble = document.querySelector('.cart-count');
    if (bubble) bubble.textContent = count;
  }

  // Add-to-cart via AJAX for any form with data-product-form
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding…'; submitBtn.disabled = true; }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
          openCart();
          if (submitBtn) {
            submitBtn.classList.add('is-added');
            setTimeout(function () { submitBtn.classList.remove('is-added'); }, 450);
          }
          var bubble = document.querySelector('.cart-count');
          if (bubble) {
            bubble.classList.add('is-bumped');
            setTimeout(function () { bubble.classList.remove('is-bumped'); }, 450);
          }
        })
        .catch(function (err) { console.error('Add to cart failed', err); })
        .finally(function () {
          if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        });
    });
  });

  // Cart quantity change / remove inside drawer (delegated)
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      var key = removeBtn.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
        });
    }
  });

  // Product gallery thumbnail swap
  document.querySelectorAll('.product__thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product__gallery-main img');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full') || thumb.src;
    });
  });
});
